import { useState, type FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { acesso } from '../api/acesso'
import { Aviso } from '../componentes/Aviso'
import { Botao } from '../componentes/Botao'
import { Campo } from '../componentes/Campo'
import { mensagemDeErro } from './mensagemDeErro'
import './acesso.css'

/**
 * Esqueci minha senha.
 *
 * A confirmação é sempre a mesma, exista o e-mail ou não — o servidor já
 * responde assim, e a tela precisa acompanhar. Uma mensagem do tipo "e-mail não
 * encontrado" transformaria esta tela num verificador de quem trabalha na
 * Rio DG.
 */
export function RecuperarSenha() {
  const { t } = useTranslation()

  const [email, setEmail] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  async function pedir(evento: FormEvent) {
    evento.preventDefault()
    setErro(null)
    setEnviando(true)

    try {
      await acesso.recuperar(email)
      setEnviado(true)
    } catch (e) {
      setErro(mensagemDeErro(e, t))
    } finally {
      setEnviando(false)
    }
  }

  return (
    <main className="acesso">
      <div className="acesso__cartao">
        <h1 className="acesso__titulo">{t('recuperar.titulo')}</h1>

        {enviado ? (
          <>
            <Aviso tom="sucesso">{t('recuperar.enviado')}</Aviso>
            <p className="acesso__descricao">{t('recuperar.enviadoDetalhe')}</p>

            <div className="acesso__acoes">
              <a className="acesso__link" href="/">
                {t('recuperar.voltar')}
              </a>
            </div>
          </>
        ) : (
          <form onSubmit={pedir} noValidate>
            <p className="acesso__descricao">{t('recuperar.descricao')}</p>

            {erro && <Aviso tom="perigo">{erro}</Aviso>}

            <Campo
              rotulo={t('acesso.email')}
              type="email"
              name="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              obrigatorio
              autoFocus
            />

            <div className="acesso__acoes">
              <Botao type="submit" variante="primario" carregando={enviando}>
                {t('recuperar.enviar')}
              </Botao>

              <a className="acesso__link" href="/">
                {t('recuperar.voltar')}
              </a>
            </div>
          </form>
        )}
      </div>
    </main>
  )
}
